import { Shell } from 'lucide-react';
import CtaBand from '../components/CtaBand';
import PageLead from '../components/PageLead';

export default function Presentation() {
  return (
    <>
      <PageLead eyebrow="Qui suis-je ?" title={<>Derrière Vague de Mots,<br /><em>une passion de toujours.</em></>} />
      <section className="story-section container-wide">
        <img className="story-photo" src="/assets/photo-marjorie.jpg" alt="Marjorie écrit dans un carnet" />
        <div className="story-copy">
          <h2>Mon histoire</h2><div className="mini-wave" />
          <p>Depuis toute petite, les livres font partie de ma vie.</p>
          <p>J’ai toujours aimé me perdre entre les pages, plonger dans les mots et parfois les maux des autres, vivre mille vies, découvrir mille histoires. La lecture a toujours été pour moi bien plus qu’un simple passe-temps : une façon de ressentir, de voyager, de comprendre et de m’évader.</p>
          <p>Pendant plusieurs années, j’ai accompagné bénévolement des auteurs et autrices, découvrant peu à peu le plaisir de porter un regard extérieur sur leurs écrits, d’en percevoir les subtilités et de contribuer à leur évolution.</p>
          <p className="story-accent">Et puis, ce qui était une passion est devenu une évidence.</p>
          <p>J’ai choisi de me professionnaliser comme une évidence afin de pouvoir exhausser au mieux vos mots, vos écrits, vos histoires.</p>
          <p>Aujourd’hui, à travers Vague de Mots, j’accompagne vos textes avec bienveillance et rigueur, convaincue que chaque écriture est unique et mérite toute l’attention nécessaire pour révéler son plein potentiel, tout en respectant votre voix et votre intention.</p>
          <div className="shell-rule"><Shell size={28} /><span /></div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
